import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=b9c9ac58"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9c9ac58')) {
      api.createRecord('b9c9ac58', component.options)
    } else {
      api.reload('b9c9ac58', component.options)
    }
    module.hot.accept("./profile.vue?vue&type=template&id=b9c9ac58", function () {
      api.rerender('b9c9ac58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/profile.vue"
export default component.exports